import { z } from 'zod'

export const CRM_EMAIL_MARK_TRANSCRIPT_CONTRACT_VERSION = '1.0.0' as const

/** The mark-transcript action reuses the transcript-ingest response projection. */
export const crmEmailMarkTranscriptResponseSchema = z.object({
  contract_version: z.literal(CRM_EMAIL_MARK_TRANSCRIPT_CONTRACT_VERSION),
}).passthrough()

export type CrmEmailMarkTranscriptResponse = z.infer<typeof crmEmailMarkTranscriptResponseSchema>
